export default __webpack_public_path__ + "static/media/DIPCHIP_icon.578ff17d.png";